import get from 'lodash/get';
import { connect } from 'react-redux';
import { getCurrentUser, getPublicSession } from '../publicSession/selectors';
import { showDealerPopup } from '../Modals/redux/actionCreators';
const mapStateToProps = (state)=>({
        userGuid: get(getCurrentUser(state), 'useridUuid'),
        biClientId: get(getPublicSession(state), 'biClientId'),
        biClientIdSigned: get(getPublicSession(state), 'biClientIdSigned')
    });
const mapDispatchToProps = {
    showDealerPopup
};
export default connect(mapStateToProps, mapDispatchToProps);
